import { createApp } from 'vue'
import App from '@/page/vue/2025/index.vue'
import '@/styles/index.scss'
import tongji from '@/utils/tongji.js'; //引入统计
import initShare from '@/utils/wxShare.js'
import Antd from 'ant-design-vue'
import Vant from 'vant'
import 'ant-design-vue/dist/antd.css'
import 'animate.css'
import '@/styles/index.scss'
import 'vant/lib/index.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji()
initShare({
  title: 'ISC.AI 2025 大会盛幕即起',
  desc: '8.6-8.7日，AI+安全双域盛会开启',
  imgUrl: 'https://p4.ssl.qhimg.com/t110b9a9301d7f1d7d4bae587ce.png',
  link: window.location.href
})


const app = createApp(App)
app.use(Antd)
app.use(Vant)
app.use(ElementPlus)
app.mount('#app')







